/**
 * Chinese render vocabulary.
 *
 * Self-registering: importing this module makes the words available to
 * `render(node, 'zh')`. Kept separate from the profile so a parse-only
 * bundle can drop it — see lexicon-registry.ts for why that separation exists.
 */
import type { LanguageLexicon } from '../generators/profiles/types';
import { registerLexicon } from '../lexicon-registry';

export const chineseLexicon: LanguageLexicon = {
  events: {
    blur: { primary: '失焦' },
    change: { primary: '改变' },
    click: { primary: '点击' },
    dblclick: { primary: '双击' },
    focus: { primary: '聚焦' },
    input: { primary: '输入' },
    keydown: { primary: '按键按下' },
    keypress: { primary: 'keypress' },
    keyup: { primary: '松键' },
    load: { primary: '加载' },
    mousedown: { primary: 'mousedown' },
    mouseenter: { primary: 'mouseenter' },
    mouseleave: { primary: 'mouseleave' },
    mousemove: { primary: '鼠标移动' },
    mouseout: { primary: '鼠标移出' },
    mouseover: { primary: '鼠标移入' },
    mouseup: { primary: 'mouseup' },
    reset: { primary: '重置' },
    resize: { primary: '调整大小' },
    scroll: { primary: '滚动' },
    submit: { primary: '提交' },
    touchcancel: { primary: 'touchcancel' },
    touchend: { primary: 'touchend' },
    touchmove: { primary: '触摸移动' },
    touchstart: { primary: '触摸开始' },
    unload: { primary: '卸载' },
  },
  logical: {
    and: { primary: '和' },
    bind: { primary: '绑定' },
    changes: { primary: '改变时' },
    contains: { primary: '包含' },
    else: { primary: '否则' },
    end: { primary: '结束' },
    equals: { primary: '等于' },
    exists: { primary: '存在' },
    has: { primary: '有' },
    have: { primary: '有' },
    includes: { primary: '包括' },
    is: { primary: '是' },
    live: { primary: '实时' },
    matches: { primary: '匹配' },
    not: { primary: '非' },
    or: { primary: '或' },
    otherwise: { primary: '要不然' },
    then: { primary: '那么' },
    when: { primary: '当' },
    where: { primary: '哪里' },
  },
  temporal: {
    h: { primary: '时' },
    hour: { primary: '小时' },
    hours: { primary: '小时' },
    millisecond: { primary: '毫秒' },
    milliseconds: { primary: '毫秒' },
    min: { primary: '分' },
    minute: { primary: '分钟' },
    minutes: { primary: '分钟' },
    ms: { primary: '毫秒' },
    s: { primary: '秒' },
    second: { primary: '秒' },
    seconds: { primary: '秒' },
    times: { primary: '次' },
  },
  values: {
    body: { primary: '主体' },
    detail: { primary: '详情' },
    document: { primary: '文档' },
    element: { primary: '元素' },
    event: { primary: '事件' },
    false: { primary: '假' },
    it: { primary: '它' },
    its: { primary: '它的' },
    me: { primary: '我' },
    my: { primary: '我的' },
    myself: { primary: '我自己' },
    null: { primary: '空' },
    result: { primary: '结果' },
    target: { primary: '目标' },
    true: { primary: '真' },
    undefined: { primary: '未定义' },
    value: { primary: '值' },
    window: { primary: '窗口' },
    you: { primary: '你' },
    your: { primary: '你的' },
    yourself: { primary: '你自己' },
  },
  attributes: {
    attribute: { primary: '属性' },
    attributes: { primary: '属性集' },
    class: { primary: '类' },
    classes: { primary: '类别' },
    properties: { primary: '特性集' },
    property: { primary: '特性' },
    style: { primary: '样式' },
    styles: { primary: '样式集' },
  },
  expressions: {
    at: { primary: '在' },
    characters: { primary: '字符' },
    children: { primary: '子级' },
    closest: { primary: '最近的' },
    empty: { primary: '空的' },
    'ends with': { primary: '以结尾' },
    exclusive: { primary: '排除' },
    first: { primary: '第一个' },
    'ignoring case': { primary: '忽略大小写' },
    inclusive: { primary: '包含' },
    'joined by': { primary: '用_连接' },
    last: { primary: '最后一个' },
    'mapped to': { primary: '映射为' },
    next: { primary: '下一个' },
    no: { primary: '没有' },
    parent: { primary: '父级' },
    prev: { primary: '上个' },
    previous: { primary: '上一个' },
    random: { primary: '随机' },
    some: { primary: '一些' },
    'sorted by': { primary: '按_排序' },
    'split by': { primary: '按_分割' },
    'starts with': { primary: '以开头' },
    within: { primary: '之内' },
  },
};

registerLexicon('zh', chineseLexicon);
